/**
 * English website copy — the translation of content_de.ts, which is the
 * leading language.
 *
 * The texts live as JSON in src/content/ and are edited through the editing
 * interface at /admin. This module only names and types them.
 *
 * `CONTENT` is annotated with `typeof CONTENT_DE` on purpose: it is the check
 * that keeps the two languages structurally identical. If a key exists in
 * German but not in English, the build fails here rather than rendering an
 * empty heading somewhere in production.
 */

import orgJson from '../../content/org.json';
import displayJson from '../../content/display.json';
import homeJson from '../../content/home.json';
import organisationJson from '../../content/organisation.json';
import mitmachenJson from '../../content/mitmachen.json';
import socialJson from '../../content/social.json';
import podcastJson from '../../content/podcast.json';
import legalJson from '../../content/legal.json';
import { CONTENT_DE, PodcastEpisode, PodcastPlatform } from './content_de';

export const ORG_INFO = orgJson.en;
export const DISPLAY = displayJson.en;
export const HOME_CONTENT = homeJson.en;
export const ORGANISATION = organisationJson.en;
export const MITMACHEN = mitmachenJson.en;
export const SOCIAL_MEDIA = socialJson.en;
export const LEGAL_CONTENT = legalJson.en;

export const PODCAST = {
  ...podcastJson.en,
  platforms: { ...podcastJson.en.platforms, items: podcastJson.en.platforms.items as PodcastPlatform[] },
  episodes: { ...podcastJson.en.episodes, items: podcastJson.en.episodes.items as PodcastEpisode[] },
};

export const CONTENT: typeof CONTENT_DE = {
  org: ORG_INFO,
  home: HOME_CONTENT,
  organisation: ORGANISATION,
  mitmachen: MITMACHEN,
  socialMedia: SOCIAL_MEDIA,
  podcast: PODCAST,
  legal: LEGAL_CONTENT,
  display: DISPLAY,
};
